import React, { useState, useEffect } from 'react';
import './PerfilData.css';
import baseURL from '../../url';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faEnvelope, faUserShield, faKey, faSave, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function PerfilData() {
    const [usuario, setUsuario] = useState({});
    const [nombre, setNombre] = useState('');
    const [email, setEmail] = useState('');
    const [nuevaPassword, setNuevaPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [guardando, setGuardando] = useState(false);

    useEffect(() => {
        cargarUsuario();
    }, []);

    const cargarUsuario = async () => {
        try {
            const res = await fetch(`${baseURL}/userLogued.php`);
            const data = await res.json();
            if (data && data.idUsuario) {
                setUsuario(data);
                setNombre(data.nombre || '');
                setEmail(data.email || '');
            }
        } catch (e) {
            console.error('Error al cargar perfil:', e);
        }
    };

    const handleActualizarPerfil = async (e) => {
        e.preventDefault();

        if (!nombre.trim()) {
            toast.warn('El nombre es obligatorio.');
            return;
        }

        if (nuevaPassword && nuevaPassword.length < 6) {
            toast.warn('La contraseña debe tener al menos 6 caracteres.');
            return;
        }

        if (nuevaPassword && nuevaPassword !== confirmPassword) {
            toast.error('Las contraseñas no coinciden.');
            return;
        }

        setGuardando(true);
        try {
            const payload = {
                nombre: nombre.trim(),
            };
            if (nuevaPassword) {
                payload.contrasena = nuevaPassword;
            }

            const res = await fetch(`${baseURL}/usuarioPut.php?idUsuario=${usuario.idUsuario}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            const data = await res.json();
            setGuardando(false);

            if (data.mensaje) {
                Swal.fire({
                    title: '¡Perfil actualizado!',
                    text: data.mensaje || 'Tus datos han sido guardados correctamente.',
                    icon: 'success'
                });
                setNuevaPassword('');
                setConfirmPassword('');
                cargarUsuario();
            } else {
                toast.error(data.error || 'No se pudo actualizar el perfil.');
            }
        } catch (err) {
            setGuardando(false);
            console.error(err);
            toast.error('Error de red al actualizar perfil.');
        }
    };

    return (
        <div className="perfilWrapper">
            <ToastContainer />
            <div className="perfilHeader">
                <div className="perfilAvatarLarge">
                    {nombre ? nombre.charAt(0).toUpperCase() : 'U'}
                </div>
                <div>
                    <h2>Mi Perfil</h2>
                    <p className="perfilSubtitle">Administra tu información personal y credenciales de acceso</p>
                </div>
            </div>

            <div className="perfilContentGrid">
                {/* Tarjeta de Datos de Cuenta */}
                <div className="perfilCard">
                    <h3>Información de Cuenta</h3>
                    <div className="perfilMetaRow">
                        <FontAwesomeIcon icon={faUserShield} className="metaIcon" />
                        <div>
                            <span className="metaLabel">Rol en el sistema:</span>
                            <span className="roleBadgeLarge">{usuario.rol || 'admin'}</span>
                        </div>
                    </div>

                    <div className="perfilMetaRow">
                        <FontAwesomeIcon icon={faEnvelope} className="metaIcon" />
                        <div>
                            <span className="metaLabel">Correo electrónico:</span>
                            <strong className="metaVal">{email}</strong>
                        </div>
                    </div>

                    <div className="perfilMetaRow">
                        <FontAwesomeIcon icon={faCalendarAlt} className="metaIcon" />
                        <div>
                            <span className="metaLabel">Fecha de registro:</span>
                            <span className="metaVal">{usuario.createdAt || 'Registrado'}</span>
                        </div>
                    </div>
                </div>

                {/* Formulario de Modificación */}
                <div className="perfilCard">
                    <h3>Actualizar Datos</h3>
                    <form onSubmit={handleActualizarPerfil} className="perfilForm">
                        <div className="formGroup">
                            <label><FontAwesomeIcon icon={faUser} /> Nombre completo:</label>
                            <input
                                type="text"
                                value={nombre}
                                onChange={(e) => setNombre(e.target.value)}
                                required
                            />
                        </div>

                        <div className="formGroup">
                            <label><FontAwesomeIcon icon={faKey} /> Nueva contraseña (opcional):</label>
                            <input
                                type="password"
                                placeholder="Dejar en blanco para mantener la actual"
                                value={nuevaPassword}
                                onChange={(e) => setNuevaPassword(e.target.value)}
                            />
                        </div>

                        {nuevaPassword && (
                            <div className="formGroup">
                                <label><FontAwesomeIcon icon={faKey} /> Confirmar nueva contraseña:</label>
                                <input
                                type="password"
                                placeholder="Repite la nueva contraseña"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                required
                            />
                            </div>
                        )}

                        <button type="submit" className="btnGuardarPerfil" disabled={guardando}>
                            <FontAwesomeIcon icon={faSave} /> {guardando ? 'Guardando...' : 'Guardar Cambios'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}
